/**
 * ท้ายหน้าของทุกหน้าในระบบ
 *
 * มีสองชั้นโดยตั้งใจ
 *   ชั้นบน  บอกที่มาของข้อมูล — ทะเบียนตำแหน่งต้นทาง
 *   ชั้นล่าง แถบเจ้าของงาน
 *
 * ⚠ prop `synthetic` ถูกถอดออกแล้ว ผู้ใช้สั่งให้เอาข้อความกำกับชุดสาธิตออกทั้งระบบ
 *   ถ้าจะเอากลับมา ให้รับ prop เดิมและต่อค่ามาจาก summary.synthetic เหมือนก่อน
 *
 * ใช้ทั้งในหน้าที่เข้าสู่ระบบแล้ว และหน้าเข้าสู่ระบบเอง (ที่นั่นส่ง source={false})
 */
export function SiteFooter({
  source = true,
}: {
  /** false = แสดงเฉพาะแถบเจ้าของงาน ไม่ต้องบอกที่มาข้อมูล (ใช้กับหน้าเข้าสู่ระบบ) */
  source?: boolean;
}) {
  return (
    <footer className="foot">
      {source && (
        <div className="wrap">
          <p className="foot-src">
            ที่มา: ทะเบียนตำแหน่ง DPIS (rpt_position) ของสำนักงานปลัดกระทรวงการคลัง
            โครงสร้างตำแหน่งและสถานะการถือครองเป็นข้อมูลจริง
          </p>
        </div>
      )}

      <div className="foot-bar">{ownerLine()}</div>
    </footer>
  );
}

/**
 * ชื่อเจ้าของงานท้ายหน้า
 *
 * ⚠ ปี พ.ศ. คำนวณจากวันที่จริง ไม่ใช่เลขที่พิมพ์ไว้ตายตัว
 *   เดิมเขียน "©2026" ไว้ตรง ๆ สองที่ในโค้ด พอขึ้นปีใหม่มันจะค้างอยู่ปีเดิมทั้งระบบ
 *   จนกว่าจะมีคนสังเกตเห็นและไล่แก้ทีละที่ — ซึ่งไม่มีใครสังเกตท้ายหน้า
 *
 * ⚠ ใช้ พ.ศ. ไม่ใช่ ค.ศ. — ทุกปีที่แสดงบนหน้าจอนี้เป็น พ.ศ. ทั้งหมด
 *   (วันเกษียณ · ปีงบประมาณ · ประวัติการดำรงตำแหน่ง) ปี ค.ศ. ที่ท้ายหน้าเพียงที่เดียว
 *   อ่านแล้วสะดุด และคนที่อ่านเร็ว ๆ จะนึกว่าระบบคำนวณปีผิด
 */
export function ownerLine(): string {
  return `KOOKIT © พ.ศ. ${new Date().getFullYear() + 543}`;
}
